import React, { useState, useRef, useEffect } from 'react';
import './Tooltip.less';
import clsx from 'clsx';

interface TooltipProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * @deprecated It makes sense to use react-tooltip component in the future, that provides more flexibility.
 */
export default function Tooltip({ title, children, className }: TooltipProps) {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (ref.current) {
      setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth);
    }
  }, [children]);

  return (
    <span className="tooltip-container">
      <span ref={ref} className={clsx('tooltip-text', className)}>
        {children}
      </span>

      {isOverflowed && (
        <span className="tooltip-popup">{title || children}</span>
      )}
    </span>
  );
}
